import React from "react";
import Navbar from "Pages/Shared/Navbar/Navbar";
import { Outlet } from "react-router-dom";
import Footer from "Pages/Shared/Footer/Footer";

const Main = () => {
  return (
    <div>
      <Navbar />
      <Outlet /> {/* Outlet is used to render the child routes */}
      <Footer/>
    </div>
  );
};

export default Main;
